import React from "react";
import Input from "../../../../../components/Common/Input/Input";
import classes from "./SearchSuggestionInput.module.scss";

const SearchSuggestionInput = ({
  label,
  name,
  placeholder,
  width = "30",
  height = "4",
  gap = "0",
  search = true,
  suggestionData,
  setValue,
  onDropdownOptionClick,
  ...rest
}) => {
  return (
    <div className={classes.searchSuggestionInput}>
      <Input
        label={label}
        name={name}
        placeholder={placeholder}
        labelColor="light"
        search={search}
        height={height}
        width={width}
        gap={gap}
        {...rest}
      />
      {suggestionData?.length > 0 && (
        <ul className={classes.itemList}>
          {suggestionData?.map((data) => (
            <li
              className={classes.item}
              title={data?.val}
              key={data?.id}
              onClick={() => onDropdownOptionClick(data)}
            >
              {data?.val?.length > 35
                ? data?.val?.slice(0, 35) + "..."
                : data?.val}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchSuggestionInput;
